import { useMemo, useCallback } from "react";
import { throttle } from "es-toolkit";

export default function useThrottledCallback(
  callback: (...args: Array<unknown>) => void,
  { wait, trailing = true }: { wait: number; trailing: boolean },
  dependencies: Array<unknown>
) {
  const throttledFunction = useMemo(() => {
    const edges: ("leading" | "trailing")[] = trailing ? ["leading", "trailing"] : ["leading"];
    return throttle(callback, wait, { edges });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wait, trailing, ...dependencies]);

  const throttledCallback = useCallback(throttledFunction, [throttledFunction]);

  return throttledCallback;
}
